import React, { Fragment } from "react";
import PropTypes from 'prop-types';

import { Button } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';

const BlockButton = ({handleBlockClick, status, isSaving, ...props}) => {
    return(
        <Fragment>
            {status==="Active" ?
                <Button                                                         
                    size="small"
                    color="secondary"
                    variant="outlined"
                    startIcon={<BlockIcon />}
                    disabled={isSaving}
                    onClick={() => handleBlockClick()}
                    {...props}
                >
                    Заблокировать
                </Button>
            :
                <Button                                                         
                    size="small"
                    color="primary"
                    variant="outlined"
                    startIcon={<CheckIcon />}
                    disabled={isSaving}
                    onClick={() => handleBlockClick()}
                    {...props}
                >
                    Разблокировать
                </Button>
            }
        </Fragment>
    )
}

BlockButton.propTypes = {
    handleBlockClick: PropTypes.func,
    isSaving: PropTypes.bool
};

export default BlockButton;
